<template>
    <Card v-loading="loading">
        <p class="fs-3 m-0 info-notifs-settings">
            {{
                $l10n.__(
                    "Nous pouvons toujours vous envoyer des notifications importantes concernant votre compte et son contenu en dehors de vos paramètres de notification préférés. Ces préférences ne s'appliqueront qu'à vous.",
                )
            }}
        </p>
        <div class="mt-6">
            <h3 class="m-0">{{ $l10n.__('Ne pas déranger') }}</h3>
            <p class="fs-3 mt-2">
                {{ $l10n.__('Vous pouvez désactiver l’ensemble des notifications.') }}
            </p>
            <div class="b-1 rounded">
                <div class="p-3 flex-level">
                    <span class="fs-3 bold">{{ $l10n.__('Activer ne pas déranger') }}</span>
                    <el-switch
                        v-model="notDisturbing"
                        class="flex-item-right"
                        activeColor="#13ce66"
                        @change="updateNotificationsSettings"
                    >
                    </el-switch>
                </div>
            </div>
        </div>
        <div class="mt-6">
            <h3 class="m-0">{{ $l10n.__('Activer les notifications pour :') }}</h3>
            <div class="b-1 rounded mt-3">
                <div class="px-3 pt-3 pb-2 flex-level">
                    <span class="fs-3 bold">{{ $l10n.__('Mentions') }}</span>
                    <el-switch
                        v-model="mentionned"
                        class="flex-item-right"
                        activeColor="#13ce66"
                        @change="updateStaffMentionned"
                    >
                    </el-switch>
                </div>
                <p class="m-0 px-3 pb-3 fs-3">
                    {{
                        $l10n.__(
                            'Recevez une notification lorsque vous êtes mentionné dans un commentaire, un objet, etc.',
                        )
                    }}
                </p>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from 'vcomponents/common/card/Card.vue';
import NotificationSettingsApi from 'api/notification/Settings';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('user');

export default {
    components: { Card },
    data() {
        return {
            notDisturbing: false,
            mentionned: false,
            loading: true,
            events: [],
            subscriptions: [],
        };
    },
    created() {
        this.getSettingsMetadata();
        this.getNotificationsSettings();
    },
    methods: {
        ...mapActions(['setNotifications']),
        getSettingsMetadata() {
            NotificationSettingsApi.getSettingsMetadata()
                .then((res) => {
                    this.events = res.data.events;
                    this.loading = false;
                })
                .catch((err) => {
                    Push.error(this.$l10n.__('Une erreur est survenue.'));
                });
        },
        getNotificationsSettings() {
            NotificationSettingsApi.getNotificationsSettings()
                .then((res) => {
                    this.subscriptions = res.data.subscriptions;
                    this.notDisturbing = res.data.do_not_disturb?.enabled;
                    this.setSettings();
                    this.loading = false;
                })
                .catch((err) => {
                    Push.error(this.$l10n.__('Une erreur est survenue.'));
                });
        },
        updateNotificationsSettings() {
            NotificationSettingsApi.updateNotificationsSettings({
                subscriptions: this.subscriptions,
                do_not_disturb: { enabled: this.notDisturbing },
            }).then((res) => {
                this.setNotifications(res.data);
            });
        },
        setSettings() {
            this.setStaffMentionned();
        },
        setStaffMentionned() {
            const hasSubscription = this.subscriptions.find(
                (event) => event.name === 'mention.staff',
            );
            if (hasSubscription) {
                this.mentionned = this.subscriptions
                    .find((event) => event.name === 'mention.staff')
                    .transports.includes('inapp');
            } else {
                this.subscriptions.push(
                    this.events.find((event) => event.name === 'mention.staff'),
                );
            }
        },
        updateStaffMentionned() {
            const mentionStaff = this.subscriptions.find((event) => event.name === 'mention.staff');
            mentionStaff.transports = mentionStaff.transports.filter(
                (transport) => transport !== 'inapp',
            );
            if (mentionStaff && this.mentionned) {
                mentionStaff.transports.push('inapp');
            }
            this.updateNotificationsSettings();
        },
    },
};
</script>

<style scoped>
.info-notifs-settings {
    line-height: 20px;
}
.rounded {
    border-radius: 4px;
}
</style>
